/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./src/assets/js/contact-form.js ***!
  \***************************************/
function docReady(fn) {
  // see if DOM is already available
  if (document.readyState === "complete" || document.readyState === "interactive") {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

docReady(function () {
  document.querySelectorAll('.element_input').forEach(function (el) {
    el.addEventListener('blur', function (event) {
      event.target.classList.toggle('not-empty', this.value.trim() != '');
    });
  });
});
/******/ })()
;